import { Component } from '@angular/core';
import { LayoutService } from '@auto-editor/data-access-layout';

@Component({
  selector: 'auto-editor-view-content',
  templateUrl: './view-content.component.html',
  styleUrl: './view-content.component.scss',
  standalone: false
})
export class ViewContentComponent {
  isDesktop$ = this.layoutService.isDesktop$;

  constructor(private layoutService: LayoutService) {}
}
